import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
// import vGallery from "v-gallery"
var VueScrollTo = require("vue-scrollto")
// import AOS from "aos"
// import "aos/dist/aos.css" // You can also use <link> for styles
// ..

import VueYoutube from "vue-youtube"
import VueAwesomeSwiper from "vue-awesome-swiper"

// import style
import "swiper/css/swiper.css"

Vue.use(VueAwesomeSwiper /* { default options with global component } */)

Vue.use(VueYoutube)

// AOS.init({ delay: 0 })

Vue.use(VueScrollTo)

// Vue.use(vGallery)

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: function(h) {
		return h(App)
	}
}).$mount("#app")
